interface IZordUtil {
    webPath: (url: string) => string
}

const ZordFunctions: () => IZordUtil = () => {
    return {
        webPath: (url) => {
            const cleanUrl = url.startsWith('/') ? url.slice(1) : url
            return `${window.location.origin}/${cleanUrl}`
        }
    }
}

export const ZordUtil: IZordUtil = ZordFunctions()